import { Image, Field, HTMLWrapper } from "@/storybook-components";
import { buildImgixUrl } from "@/lib";
import type { Question } from "@/types";

interface ImageQuestionProps {
  question: Question;
}

const ImageQuestion = ({ question }: ImageQuestionProps): JSX.Element => {
  return (
    <Field.Root my={4}>
      <Field.Label>
        <HTMLWrapper html={question.question} />
      </Field.Label>
      <Image
        src={
          question.useImageLink
            ? question.imageUrl
            : buildImgixUrl(question.imageUrl)
        }
        alt={question.question}
      />
    </Field.Root>
  );
};

export default ImageQuestion;
